<template>
  <div class="Capture">
    <div id="capture" class="Capture__container"></div>
    <div class="Capture__cover"></div>
  </div>
</template>
<script>
import domtoimage from 'dom-to-image'
export default {
  name: 'Capture',
  watch: {
    '$route': {
      immediate: true,
      handler() {
        // if(this.slugIsIn(['merci'])) {
        //   this.$nextTick(() =>{ this.download() })
        // }
      }
    }
  },
  computed: {
    capture() { return this.$store.getters['app/capture'] },
  },
  methods: {
    download() {
      var link = document.createElement('a')
          link.download = 'mon-portrait.png'
          link.href = this.capture
          link.click()
    },
  },
}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.Capture

  &__container
    position absolute
    top 0
    left 0
    width 326px
    height 435px

    & img 
      width 100vw
      max-width none
      transform translate(-50%, -50%)
      left 50%
      top 50%
      position absolute

  &__cover 
    width 100vw
    height 100vh
    background black
    position absolute
    top 0
    left 0

</style>































































// WEBPACK FOOTER //
// src/components/defis/components/Capture.vue